import { useState, useRef, useEffect } from 'react';
import { FiChevronDown, FiFilter } from 'react-icons/fi';

export default function Select({
  label,
  options,
  value = '',
  onChange,
  placeholder = 'Seleziona...',
  width = 'w-36'
}) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Chiude il dropdown al click fuori dal componente
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Gestione selezione
  const handleSelect = (val) => {
    onChange(val);
    setIsOpen(false);
  };


  return (
    <div ref={containerRef} className="flex flex-col relative">
      {label && <label className="mb-2 text-gray-700 font-medium">{label}</label>}

      {/* Trigger */}
      <div
        className={`flex items-center justify-between bg-white border border-gray-300 px-4 py-2 rounded shadow cursor-pointer hover:border-gray-400 ${isOpen ? 'border-gray-500' : ''} ${width}`}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <div className="flex items-center space-x-2">
          <FiFilter className="text-gray-500" />
          <span className={`${value ? 'text-gray-900' : 'text-gray-500'}`}>
            {options.find(o => o.value === value)?.label || placeholder}
          </span>
        </div>
        <FiChevronDown
          className={`h-5 w-5 text-gray-700 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </div>

      {/* Dropdown menu */}
      <div
        className={`absolute z-50 mt-11 bg-white w-full border border-gray-300 rounded shadow-lg max-h-60 overflow-auto origin-top transition-all duration-200 ease-out
          ${isOpen ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0 pointer-events-none'} ${width}`}
        style={{ transformOrigin: 'top' }}
      >
        {options.map(opt => (
          <div
            key={opt.value}
            className={`
              px-4 py-2 cursor-pointer 
              ${value === opt.value ? 'bg-yellow-100 font-medium text-yellow-900' : 'hover:bg-yellow-50 hover:text-yellow-900'}
            `}
            onClick={() => handleSelect(opt.value)}
          >
            {opt.label}
          </div>
        ))}
      </div>
    </div>
  );
}
